'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { Suspense, useEffect, useRef } from 'react'
import { trackPageView } from '../gtm'
import { trackAIReferral } from '../ai-referral'

function PageViewTrackerInner() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const isInitialLoad = useRef(true)

  // Detect generative-AI referrals once, on the entry page, where
  // document.referrer still points at the external AI platform (TNA-269).
  useEffect(() => {
    trackAIReferral()
  }, [])

  useEffect(() => {
    // Skip the initial page load — GTM's gtm.js event handles that
    if (isInitialLoad.current) {
      isInitialLoad.current = false
      return
    }

    const url = searchParams?.toString()
      ? `${pathname}?${searchParams.toString()}`
      : pathname

    // Small delay to let <title> update before we capture it
    const timer = setTimeout(() => {
      trackPageView(url)
    }, 100)

    return () => clearTimeout(timer)
  }, [pathname, searchParams])

  return null
}

/**
 * Tracks SPA route changes as virtual page views in GTM.
 * Wrap in the root layout alongside (or inside) `<AnalyticsProvider>`.
 *
 * Uses `useSearchParams()` so it must be wrapped in `<Suspense>`.
 * This component handles that internally.
 */
export function PageViewTracker() {
  return (
    <Suspense fallback={null}>
      <PageViewTrackerInner />
    </Suspense>
  )
}
